"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailAddressHelper = void 0;
class EmailAddressHelper {
    /**
     * @see https://stackoverflow.com/a/46181
     */
    static isValidEmailAddress(email) {
        if (!email)
            return false;
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line no-useless-escape
        return re.test(email.toLowerCase());
    }
    static obfuscate(email) {
        if (!email) {
            return email;
        }
        return this.obfuscateDefined(email);
    }
    static obfuscateDefined(email) {
        if (email === "Unknown" || email.trim() === "") {
            return email;
        }
        const character = "*";
        return ((email.length > 3 ? email.substring(0, 3) : email) +
            character.repeat(18));
    }
}
exports.EmailAddressHelper = EmailAddressHelper;
//# sourceMappingURL=EmailAddressHelper.js.map